import React, { FunctionComponent } from "react"
import Valine from "gatsby-plugin-valine"

/**
 * Placeholder which is attached under every post. Can be shadowed to
 * quickly integrate comments (like commento, Disqus, ...).
 */
// @ts-ignore
const Comments: FunctionComponent<{ path: string }> = ({ path }) => (
  <>
    <Valine
      style={{ margin: 15 }}
      visitor={true}
      appId="SyVUmIdmEVx7k6yLT5RCWrFS-gzGzoHsz"
      appKey="51PiabiVM933usXeOB8Vr2Gk"
      path={path}
    />
  </>
)

export default Comments
